import { getAddress, isAddress } from "ethers/lib/utils";

// matching wallet UIs
export function shortenCryptoAddress(cryptoAddressStr: string | undefined): string {
    if (!cryptoAddressStr) {
        return "--";
    }

    const cleanedStr = cryptoAddressStr.trim();
    if (!cleanedStr.length) {
        return "--";
    }

    const isEvmAddress = isAddress(cryptoAddressStr);
    const caseSensitiveAddress = isEvmAddress ? getAddress(cryptoAddressStr) : cryptoAddressStr;

    return `${caseSensitiveAddress.substring(
        0,
        isEvmAddress ? 5 : 4,
    )}...${caseSensitiveAddress.substr(caseSensitiveAddress.length - 4)}`;
}
